<div class="bottom-sheet-container" [class.show]="isShown">
  <ng-content></ng-content>
</div>

<div
  class="bottom-sheet-overlay"
  (click)="hide()"
  [class.is-hidden]="!isShown"
></div>
